import React, { Fragment, useEffect } from "react";
import { LI, SVG, UL } from "../../../AbstractElements";
import { Link, useLocation } from "react-router-dom";
import { ActiveNavLinkUrl } from "../../../Service/ActiveNavBarUrl";
import { sidebarTypes } from "../../../Type/SideBarType";
import { Href } from "../../../Constant";
import { useAppSelector } from "../../../Redux-Toolkit/Hooks";
import { useTranslation } from "react-i18next";

export const SubMenu = ({ menu, isOpen, setIsOpen, level }: sidebarTypes) => {
  const { pathname } = useLocation();
  const { sidebarIconType } = useAppSelector((state) => state.themeCustomizer);
  const { t } = useTranslation();

  useEffect(() => {
    const shouldSetActive = ({ item }: any) => {
      var returnValue = false;
      if (item?.url === pathname) {
        returnValue = true;
      }
      if (!returnValue && item?.menu) {
        item?.menu.every((subItem: any) => {
          returnValue = shouldSetActive({ item: subItem });
          return !returnValue;
        });
      }
      return returnValue;
    };

    menu.forEach((item) => {
      let gotValue = shouldSetActive({ item });
      if (gotValue) {
        let temp = isOpen;
        temp[level] = item.title;
        setIsOpen(temp);
      }
    });
  }, [isOpen, setIsOpen, level, menu, pathname]);

  return (
    <Fragment>
      {menu.map((item, index) => (
        <LI key={index}>
          <Link
            to={item.url ? item.url : Href}
            className={`${(item.menu ? item.menu.map((innerItem) => ActiveNavLinkUrl(innerItem.url)).includes(true) : ActiveNavLinkUrl(item.url)) || isOpen[level] === item.title ? "active" : ""}`}
            onClick={() => {
              const temp = isOpen;
              temp[level] = item.title !== temp[level] && item.title;
              setIsOpen(temp);
            }}>
            {item.icon1 && level === 0 && <SVG className={`${sidebarIconType}-icon`} iconId={`${sidebarIconType}-${item.icon1}`} />}
            {t(item.title)}
          </Link>
          {item.menu && (
            <span className="sub-body-arrow">
              <i className="fa fa-angle-right"></i>
            </span>
          )}
          {item.menu && (
            <UL className="sidebar-body-submenu custom-scrollbar">
              <SubMenu menu={item.menu} isOpen={isOpen} setIsOpen={setIsOpen} level={level + 1} />
            </UL>
          )}
        </LI>
      ))}
    </Fragment>
  );
};
